const initSubmenu = () => {

    // Create a condition that targets selected viewport
    const mobileQueryCheck = window.matchMedia('(min-width: 50.6875rem)');

    // Register event listener
    mobileQueryCheck.addListener(handleTabletChange);

    const handleTabletChange = (e) => {
        let elHeader = document.querySelector('.header--page'),
            elTriggers = elHeader.querySelectorAll('.main-menu__item button')

        if (e.matches) {
            // Then log the following message to the console
            console.log('Media Query Matched!')


            let elPopover  = document.createElement('div'),
                popoverActive = '',
                popoverOpen = false;

                elPopover.className = 'header__pop'
                elPopover.style.visibility = "hidden"
                elPopover.style.maxHeight = 0
                elHeader.append(elPopover)

                for (const elTrigger of elTriggers) {

                    elTrigger.addEventListener('click', function (event) {

                        if(popoverOpen == false) {
                            popoverOpen = true;
                            placeContent(this, elPopover, this.nextElementSibling)
                            openPopOver(elPopover)
                        } else {
                            if(popoverActive == this ) {
                                popoverOpen = false;
                                elPopover.innerHTML = '';
                                elPopover.style.height = '0px'
                            } else {
                                placeContent(this, elPopover, this.nextElementSibling)
                                changeHeight(elPopover)
                            }
                        }
                    })
                }

                const openPopOver = (submenu) => {
                let child = submenu.firstChild,
                    height = child.getBoundingClientRect().height + 'px'

                    submenu.style.height = '0px'
                    submenu.style.maxHeight = 'none'
                    submenu.style.visibility = "visible"
                    submenu.style.display = 'block'

                    setTimeout(function () {
                        submenu.style.height = height
                    }, 0)
            }

            const changeHeight = (submenu) => {
                let child = submenu.firstChild,
                    height = child.getBoundingClientRect().height + 'px'

                    setTimeout(function () {
                        submenu.style.height = height
                    }, 0)
            }


            const placeContent = (triggerEl, target, content) => {
                popoverActive = triggerEl
                target.innerHTML = content.innerHTML
            }
        } else {
            let navActive = false,
                submenuActive = null

            const mobileMenuTrigger = document.querySelector('.btn\\3A nav-trigger')
            mobileMenuTrigger.addEventListener('click', (event) => {
                if(navActive == false) {
                    mobileMenuTrigger.classList.add("btn:nav-trigger--open")

                    navActive = true
                } else {
                    mobileMenuTrigger.classList.remove("btn:nav-trigger--open")

                    if(submenuActive !== null ){
                        closeSubmenu()
                    }
                    navActive = false
                }

            });



            for (const elTrigger of elTriggers) {
                elTrigger.addEventListener('click', function (event) {

                    if(submenuActive === null) {
                        openSubmenu(this)
                    } else {
                        if(submenuActive == this) {
                            // Close submenu
                            closeSubmenu()
                        } else {
                            // Reset old submenu
                            closeSubmenu()

                            // Set new submenu
                            openSubmenu(this)
                        }
                    }

                });
            }

            const openSubmenu = (element) => {
                // Open submenu
                submenuActive = element
                submenuActive.dataset.active = true
                submenuActive.nextElementSibling.style.display = 'flex'
            }

            const closeSubmenu = () => {
                // Close submenu
                submenuActive.nextElementSibling.style.display = 'none'
                submenuActive.dataset.active = false
                submenuActive = null
            }
        }
    }

    // Initial check
    handleTabletChange(mobileQueryCheck);


}
